import React, { useEffect, useMemo, useState } from 'react'
import { ResponseRequest } from 'components/Types/GeneralTypes';
import { alertService } from 'components/Varios/alert_service'
import Cargando from 'components/Varios/Cargando';
import PDFViewer from 'components/Varios/PDFViewer';
import { Button, Col, Row, FormGroup } from 'react-bootstrap';
import { Label, Input } from 'reactstrap';
import { authenticationService } from 'services/authentication.service';
import { ObtenerExcelHojaVidaConsultorAcreditacionEURACE, ObtenerExcelHojaVidaConsultorAcreditacionAACSB, ObtenerExcelHojaVidaConsultorAcreditacionABET } from 'components/UsuarioGeneral/Hoja de Vida/FunctionsGenerarHojaVida'
import { ObtenerUnidadConsultor } from 'components/Consultor/FunctionsConsultor';
import AsyncSelect from 'react-select/async';
import configData from "config.json"

import Swal from 'sweetalert2'
import SelectItem2 from '../../Varios/SelectNew';
import WarningSVG from "assets/icons/Permisos/Informativa R.svg"

export default function ConsultorGenerarHojaVidaExcel() {
    const [urlHojaVida, seturlHojaVida] = useState<string>("")
    const [loading, setloading] = useState<boolean>(false)
    const [loadingDatos, setloadingDatos] = useState<boolean>(false)
    const [unidadConsultor, setunidadConsultor] = useState<string>("")
    const [tipoHojaVida, setTipoHojaVida] = useState("");
    const [idunidad, setidunidad] = useState(0);

    const [inputValueUnidad, setValueUnidad] = useState('');
    const [selectedValueUnidad, setSelectedValueUnidad] = useState(null);

    const opciones_hojavida = [
        { key: "EURACE_DOCENTES", value: "EUR-ACE (Docentes)" },
        { key: "AACSB_DOCENTES", value: "ACBSP (Docentes)" },
        { key: "ABET_DOCENTES", value: "ABET (Docentes)" },
    ];

    const handleInputChangeUnidad = value => {
        setValueUnidad(value);
    };

    const handleChangeUnidad = value => {
        setSelectedValueUnidad(value);
        setidunidad(value.idestructuraorganica);
    }

    const loadOptionsUnidad = (inputValue) => {
        if (inputValue.length > 3) return fetch(`${configData.SERVER_URL}FormularioController/ConsultorBuscarUnidad/${inputValue}`).then(res => res.json()).then(result => result.entTabla);
        else return [];
    };

    const ViewerHojaDeVida = useMemo(() => {
        if (loading) {
            return <Cargando mensaje='Generando Reporte Excel' />
        }
        if (urlHojaVida) {
            return undefined
        }
        else {
            return undefined
        }

    }, [urlHojaVida, loading])

    async function GetUnidadConsultor() {
        setloadingDatos(true);
        if (authenticationService.currentUserValue.estructuraOrganicaConsultor != 0) {
            setidunidad(authenticationService.currentUserValue.estructuraOrganicaConsultor);
            var datos = await ObtenerUnidadConsultor(authenticationService.currentUserValue.estructuraOrganicaConsultor);
            setunidadConsultor(datos);
        }
        setloadingDatos(false);
    }

    const GenerarHojaVidaAcreditacion = async () => {
        var error = "";

        if (idunidad === 0) error += "Seleccione una unidad. <br />";
        if (!tipoHojaVida) error += "Seleccione un tipo de hoja de vida. <br />";

        if (error !== "") {
            Swal.fire({
                html: error,
                imageUrl: `${WarningSVG}`,
                imageHeight: 100,
                imageAlt: "Anuncio",
                confirmButtonText: "Entendido",
                confirmButtonColor: "#243165",
            });
            return;
        }

        alertService.clear();
        setloading(true);

        try {
            let resultado: ResponseRequest | undefined;

            switch (tipoHojaVida) {
                case "EURACE_DOCENTES":
                    resultado = await ObtenerExcelHojaVidaConsultorAcreditacionEURACE(idunidad.toString());
                    break;
                case "AACSB_DOCENTES":
                    resultado = await ObtenerExcelHojaVidaConsultorAcreditacionAACSB(idunidad.toString());
                    break;
                case "ABET_DOCENTES":
                    resultado = await ObtenerExcelHojaVidaConsultorAcreditacionABET(idunidad.toString());
                    break;
            }

            if (resultado?.status === 200) {
                alertService.success("Se ha generado el reporte excel con éxito.");
            } else {
                alertService.error(resultado?.errorMessage ?? "Error inesperado.");
            }

        } finally {
            setloading(false);
        }
    };

    useEffect(() => {
        GetUnidadConsultor();
    }, [])

    return (
        <div className="content">

            <div className='titulo_seccion mb-4'>Reporte Excel - Acreditación</div>

            {authenticationService.currentUserValue.estructuraOrganicaConsultor == 0 ?

                < Row >
                    <Col md={6}>
                        <FormGroup className="mb-3">
                            <Label for="">Buscar Unidad*</Label>
                            <AsyncSelect
                                cacheOptions
                                defaultOptions
                                placeholder="Buscar unidad"
                                loadingMessage={() => "Buscando . . ."}
                                noOptionsMessage={() => "No existe información para mostrar"}
                                value={selectedValueUnidad}
                                getOptionLabel={e => e.nombre}
                                getOptionValue={e => e.idestructuraorganica}
                                loadOptions={loadOptionsUnidad}
                                onInputChange={handleInputChangeUnidad}
                                onChange={handleChangeUnidad}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                :
                < Row >
                    <Col md={6}>
                        <FormGroup className="mb-3">
                            <Label for="">Unidad*</Label>
                            <Input name="unidad" id="unidad" value={unidadConsultor} readOnly="readOnly" />
                        </FormGroup>
                    </Col>
                </Row>
            }
            <Row>
                <Col md={6}>
                    <FormGroup className="mb-3">
                        <Label for="tipoHojaVida">Tipo de Hoja de Vida*</Label>
                        <SelectItem2
                            options={opciones_hojavida.map((op) => ({
                                value: op.key,
                                label: op.value,
                            }))}
                            placeholder="-- Seleccione una opción --"
                            name="tipoHojaVida"
                            id="tipoHojaVida"
                            icon="fa-caret-down"
                            value={tipoHojaVida}
                            onChange={(selectedOption: any) => setTipoHojaVida(selectedOption)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <Button
                        color="primary"
                        className="mt-3"
                        disabled={loading}
                        onClick={GenerarHojaVidaAcreditacion}
                    >
                        Generar Reporte Excel
                    </Button>
                </Col>
            </Row>
            {
                ViewerHojaDeVida
            }
        </div>
    )
}